module.exports = __webpack_public_path__ + "static/gtmed-4fd6761bd27e5893b17ecd756fecb4e2.ttf";